import { processLeadsWithWhatsAppInfo, hasValidWhatsApp } from '../components/Filters/phoneValidation'

/**
 * Mapeia o idSituacaoInterna (Int) para o rótulo usado nos gráficos
 */
function getSituacaoFromId(idSituacaoInterna) {
  switch (idSituacaoInterna) {
    case 0:
      return 'Em Atendimento'; // Em atendimento
    case 1:
      return 'Qualificado'; // Qualificado
    case 2:
      return 'Descartado'; // Descartado - Conversa
    case 3:
      return 'Descartado'; // Descartado - Cadência
    case 4:
      return 'Não é WhatsApp'; // Não é WhatsApp
    case 5:
      return 'Retirado da etapa IA'; // Retirado da etapa IA
    case 8:
      return 'Outros Sistemas'; // Outros Sistemas
    case 6:
      return 'Novo Lead'; // Novo Lead
    case 7:
      return 'Cadência';
    default:
      return null; // caso venha algum id desconhecido
  }
}

/**
 * Versão atualizada da função aggregateChartData com verificação de WhatsApp
 * 
 * @param {Array<Object>} chartData - Array de objetos representando leads
 * @returns {Object} Objeto contendo arrays de labels e dados para uso em gráficos
 */
export function aggregateChartDataWithPhoneValidation(chartData) {
  const processedLeads = processLeadsWithWhatsAppInfo(chartData);

  const categories = [
    "Não é WhatsApp",
    "Leads Válidos",
    "Novo Lead",
    "Cadência",
    "Em Atendimento",
    "Qualificado",
    "Descartado",
    "Retirado da etapa IA",
    "Outros Sistemas"
  ];

  const counts = {
    "Em Atendimento": 0,
    "Qualificado": 0,
    "Descartado": 0,
    "Não é WhatsApp": 0,
    "Leads Válidos": 0,
    "Retirado da etapa IA": 0,
    "Outros Sistemas": 0,
    "Novo Lead": 0,
    "Cadência": 0,
  };

  if (processedLeads && Array.isArray(processedLeads)) {
    processedLeads.forEach((lead) => {
      // 🔄 Agora a situação vem do idSituacaoInterna (Int)
      const situacao = getSituacaoFromId(lead.idSituacaoInterna);
      const temWhatsApp = hasValidWhatsApp(lead);

      // Se não tem WhatsApp válido, conta como "Não é WhatsApp"
      if (!temWhatsApp) {
        counts["Não é WhatsApp"] += 1;
      } else if (
        situacao &&
        categories.includes(situacao) &&
        situacao !== "Leads Válidos" &&
        situacao !== "Não é WhatsApp"
      ) {
        // Se tem WhatsApp válido e está em uma categoria específica
        counts[situacao] += 1;
      }
    });

    const total = processedLeads.length;

    // Calcula "Leads Válidos" como o total menos as outras categorias
    counts["Leads Válidos"] = total - counts["Não é WhatsApp"];

    // Garante que não seja negativo
    if (counts["Leads Válidos"] < 0) {
      counts["Leads Válidos"] = 0;
    }

    return {
      labels: ["Total", ...categories],
      data: [total, ...categories.map(cat => counts[cat])],
      processedLeads
    };
  }

  // Caso não haja leads processados
  return {
    labels: ["Total", ...categories],
    data: [0, ...categories.map(() => 0)],
    processedLeads: []
  };
}
